'uss strict';

const component = {
    transclude: true,
    bindings: {
        main: '=',
        socket: '=',
        settings: '=',
        saveNodeInfo: '=',
        editAssociatedGroups: '=',
        createEditGroup: '=',
        deleteGroup: '=',
        getGroups: '=',
        setGroups: '='
    },
    scope: true,
    template: require('./view.html'),
    controller: function($scope) {
        require('./lateral_map.scss');

        // Force Chart Default Values
        this.gravity = 0.05; // how much the nodes are attracted to each other (between 0 & 1)
        this.charge = -10; // repulse (basically opposite of gravity) (smaller than zero can go in the 1000s) (our max is -2000)
        this.link_distance = 80; // distance of a link between nodes
        this.link_strength = 0.5; // link flexibility (if set to 1, every link will be the link distance, 0 the link distance is basically ignored)
        this.friction = 0.6; // how much friction the chart has when a node moves (how fast for it to slow down) (between 0 & 1)
        this.alpha = 0.05; // radius of the nodes
        this.padding = 1; // padding for the node collisions (how much space between nodes)
        this.maxRadius = 10; // radius of the nodes

        this.shiftKey = false;   // used to know when the "shift" button is pressed
        this.already_collapsed_ips = []; // ips that are currently in a cluster
        this.links = []; // array of links
        this.nodes = []; // arra of nodes
        this.allNodes = {}; // Every single node possible from the network assets table, (all network assets and new nodes) even if it does not show up on map
        this.nodeArray = {};   // object of all the known nodes, key = IP, value = node object (for easy access) and to show all the IPs connected to it
        this.allLinks = {};   // list of all the possible links already existed (used so you dont get duplicate links)
        this.l7_between_nodes = {}; // object of all the possible L7 betweem IPs for easy access in the sidebnar
        this.nodes_object = {};

        // when resizing the window, this is used so it does not fire for every pixel (can put a ms between)
        this.waitForFinalEvent = (function () {
            var timers = {};
            return function (callback, ms, uniqueId) {
                if (!uniqueId) {
                    uniqueId = "slider"; // don't call this twice without a uniqueId
                }
                if (timers[uniqueId]) {
                    clearTimeout (timers[uniqueId]);

                }
                timers[uniqueId] = setTimeout(callback, ms);
            };
        })();

        // returns the path for the SVG depending on the node type
        this.svgType = function(type) {
            switch(type) {
                case 'Gateway':
                    return 'M10,21.41H4.59V16h2v1.86L10,14.59,11.41,16,7.86,19.41H10v2ZM16,6.59v-2h5.41V10h-2V8.14L16,11.41,14.59,10l3.56-3.41H16Zm1.4,14.14h-2V15.31h5.41v2H19l3.27,3.41-1.41,'+
                    '1.41L17.4,18.59v2.14ZM8.61,5.23h2v5.41H5.19v-2H7.05L3.78,5.23,5.19,3.81,8.61,7.37V5.23Z';
                case 'Server':
                    return 'M18,22h7v2H18V22ZM1,24H8V22H1v2Zm0-9H25v5H14.19v1h3.05v4H8.82V21H12.1V20H1V15Zm2.09,3H5.17V16H3.09v2ZM1,8H25v5H1V8Zm2.09,3H5.17V9H3.09v2ZM25,1V6H1V1H25ZM5.17,2H3.09V4H5.17V2Z';
                case 'DNS Server':
                    return 'M14,21h3v4H9V21h3V20h2v1Zm4,3h7V22H18v2ZM1,24H8V22H1v2ZM6,7H3V3H6V1H1V9H6V7ZM20,1V3h3V7H20V9h5V1H20ZM12,7H8V9h4V7Zm0-6H8V3h4V1Zm6,6H14V9h4V7Zm0-6H14V3h4V1ZM6,6H8V4H6V6ZM6,17H3V13H6V11H1v8H6V17Zm14-4'+
                        'h3v4H20v2h5V11H20v2Zm-8,4H8v2h4V17ZM8,13h4V11H8v2Zm10,4H14v2h4V17Zm0-6H14v2h4V11ZM6,16H8V14H6v2Z';
                case 'Web Server':
                    return 'M5.06,21A4,4,0,0,1,1,16.64a4.09,4.09,0,0,1,3.4-4.31S4.93,9.25,6.68,9.25A2.76,2.76,0,0,1,9,10.41s1.21-4.94,5.79-4.94c5.71,0,5.87,7.16,5.87,7.16s4.36,0.64,4.36,4C25,21,21.24,21,21.24,21H5.06Z';
                case 'File Server':
                    return 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z';                    
                case 'DHCP Server':
                    return 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z';                    
                case 'Database':
                    return 'M384 960C171.969 960 0 902.625 0 832c0-38.625 0-80.875 0-128 0-11.125 5.562-21.688 13.562-32C56.375 727.125 205.25 768 384 768s327.625-40.875 370.438-96c8 10.312 13.562 20.875 13.562 32 0 37.062 0 76'+
                        '.375 0 128C768 902.625 596 960 384 960zM384 704C171.969 704 0 646.625 0 576c0-38.656 0-80.844 0-128 0-6.781 2.562-13.375 6-19.906l0 0C7.938 424 10.5 419.969 13.562 416 56.375 471.094 205.25 512 384 512s32'+
                        '7.625-40.906 370.438-96c3.062 3.969 5.625 8 7.562 12.094l0 0c3.438 6.531 6 13.125 6 19.906 0 37.062 0 76.344 0 128C768 646.625 596 704 384 704zM384 448C171.969 448 0 390.656 0 320c0-20.219 0-41.594 0-64 0-2'+
                        '0.344 0-41.469 0-64C0 121.34400000000005 171.969 64 384 64c212 0 384 57.344 384 128 0 19.969 0 41.156 0 64 0 19.594 0 40.25 0 64C768 390.656 596 448 384 448zM384 128c-141.375 0-256 28.594-256 64s114.625 64 25'+
                        '6 64 256-28.594 256-64S525.375 128 384 128z';                    
                case 'Mobile':
                    return 'M18,1.77H8a2,2,0,0,0-2,2v18a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2v-18A2,2,0,0,0,18,1.77Zm0,18H8v-14H18v14Z';                    
                case 'Laptop':
                    return 'M21.67,19.5a2.17,2.17,0,0,0,2.17-2.17V6.5a2.17,2.17,0,0,0-2.17-2.17H4.33A2.17,2.17,0,0,0,2.17,6.5V17.33A2.17,2.17,0,0,0,4.33,19.5H0v2.17H26V19.5H21.67ZM4.33,6.5H21.67V17.33H4.33V6.5Z';                    
                case 'Desktop':
                    return 'M26,2.34H0v17H9l-1.32,5H18.81l-1.48-5H26v-17Zm-11.5,16h-2v-2h2v2Z';                    
                case 'Endpoint':
                    return 'M18.25,7.75A5.25,5.25,0,1,1,13,2.5,5.25,5.25,0,0,1,18.25,7.75ZM23.5,19.66a15.68,15.68,0,0,0-21,0V23.5h21V19.66Z';                    
                case 'Printer':
                    return 'M20,9H6a3,3,0,0,0-3,3v6H7v4H19V18h4V12A3,3,0,0,0,20,9ZM17,20H9V15h8v5Zm3-7a1,1,0,1,1,1-1A1,1,0,0,1,20,13ZM19,4H7V8H19V4Z';                    
                case 'Access Point':
                    return 'M15.9,18.55a2.71,2.71,0,1,1-2.71-2.67A2.69,2.69,0,0,1,15.9,18.55ZM3.25,11.83a12.18,12.18,0,0,1,19.88,0l1.56-1.12a14.13,14.13,0,0,0-23,0ZM6.2,14a8.49,8.49,0,0,1,14,0l1.6-1.15a10.49,10.49,0,0,0-17.18,0Zm3,'+
                    '2.14a4.77,4.77,0,0,1,8.05,0l1.64-1.18a6.83,6.83,0,0,0-11.34,0Z';                    
                case 'Domain Controller':
                    return 'M67.998,0H21.473c-1.968,0-3.579,1.61-3.579,3.579v82.314c0,1.968,1.61,3.579,3.579,3.579h46.525c1.968,0,3.579-1.61,3.579-3.579V3.579C71.577,1.61,69.967,0,67.998,0z M44.736,65.811c-2.963,0-5.368-2.409-5.368-5.36'+
                    '8c0-2.963,2.405-5.368,5.368-5.368c2.963,0,5.368,2.405,5.368,5.368C50.104,63.403,47.699,65.811,44.736,65.811z M64.419,39.704H25.052v-1.789h39.367V39.704z M64.419,28.967H25.052v-1.789h39.367V28.967z M64.419,17.336H25.0'+
                    '52V6.599h39.367V17.336z';                    
                case 'Phone':
                    return 'M7.81,11.79a15.15,15.15,0,0,0,6.59,6.59l2.2-2.2a1,1,0,0,1,1-.24,11.41,11.41,0,0,0,3.57.57,1,1,0,0,1,1,1V21a1,1,0,0,1-1,1,17,17,0,0,1-17-17,1,1,0,0,1,1-1h3.5a1,1,0,0,1,1,1,11.36,11.36,0,0,0,.57,3.57,1,1,0,0,1-.25,1Z';                    
                case 'Switch':
                    return 'M12,20.76H6.57l1.55,1.55-1.6,1.6L2.17,19.57l4.34-4.34,1.6,1.6L6.57,18.49H12v2.27ZM12,10H6.57L8.12,11.5l-1.6,1.6L2.17,8.76,6.51,4.42,8.12,6,6.57,7.68H12V10Zm7.77,11.'+
                    '74-1.6-1.6,1.55-1.55H14.28V16.27H19.7l-1.55-1.66,1.6-1.6,4.34,4.34Zm0-11-1.6-1.6L19.7,7.53H14.28V5.27H19.7L18.15,3.6,19.76,2,24.1,6.34Z';                    
                case 'type':
                    return 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1'+
                        '.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.'+
                        '78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z';                    
                case 'group':
                    return 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.'+
                        '5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z';                    
                case 'cluster':
                    return 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02'+
                        '-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.'+
                        '36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z';                    
                case 'selected':
                    return 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.9'+
                        '4V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z';                    
                case 'connecting':
                    return 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z';                    
                case 'ioc':
                    return 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z';                    
                case 'new':
                    return 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z';                    
                default:
                    return 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z';
                    
            }
        }

        // returns the group color from its ID
        this.getGroupColor = function(id) {
            let g;
            for (g in $scope.groups) {
                if (id === g) {
                    return $scope.groups[g].color
                }
            }
            return false
        }

        // returns a color from an ID or IOC severity
		this.color = function (id) {
			if (this.getGroupColor(id)) {
				return this.getGroupColor(id)
			} else if (typeof id === "number") {
				switch(id) {
					case 4:
				        return "#ff3131";						
					case 3:
						return "#f88b12";						
					case 2:
						return "#f5d800";						
					case 1:
						return "#377fc7";						
					case 0:
					default:
						return "#999";						
				}
			} else {
				return "#000000"
			}
        }

    }
}

component.$inject = ['$scope'];

module.exports = function(ngModule) {
    ngModule.component('lateralmap', component)
    ngModule.directive('lmForcechart', require('./lm_forcechart.ts'));
    // ngModule.directive('lmForcechart', require('./lm_test.js'));
    ngModule.directive('lmSidebar', require('./lm_sidebar'));
}



/** WEBPACK FOOTER **
 ** ./src/pages/directives/lateralmap/index.js
 **/